import React from "react";
import styles from "./Bio.module.css";
import { getGravatarURL } from "../utils/getGravatarURL";

function Bio(props) {
  let photoURL = getGravatarURL({
    email: "imagetext.xyz@gmail.com",
    size: 56,
  });

  return (
    <div
      className={`
      ${styles.Bio}
      ${props.className || ""}
    `}
    >
      <div className={styles.avatarWrap}>
        <img src={photoURL} alt="imagetext.xyz" />
      </div>
      <div className={styles.content}>
        <p className={styles.text}>
          Unlocking the power of OCR at{" "}
          <a
            href="https://imagetext.xyz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            imagetext.xyz
          </a>
          — streamline tasks and increase productivity with free online text
          recognition.
        </p>
      </div>
    </div>
  );
}

export default Bio;
